<div class="esf-main-layout esf-main-layout--has-header esf-main-layout--has-sidebar esf-main-layout--has-inner-sidebar">
  <ng-container *ngIf="sidebarOptions.hasSidebar">
    <aside class="esf-main-sidebar esf-main-sidebar--secondary -has-transition" [class.-is-open]="sidebarOptions.isOpened">
      <div class="esf-main-sidebar__content" [class.-is-open]="sidebarOptions.isOpened">
        <app-sidebar></app-sidebar>
      </div>
      <div class="esf-main-sidebar__meta">
        <app-footer></app-footer>
      </div>
    </aside>
    <div class="esf-hamburger esf-hamburger--sidebar -has-transition" (click)="toggleSidebar()" [class.-is-open]="sidebarOptions.isOpened">
      <span class="esf-hamburger__icon"></span>
    </div>
  </ng-container>
  <router-outlet></router-outlet>
</div>
